import React, {Component} from 'react';
import { CONSENT_SIGNING } from "../../../constants";

class BaseElectronicSign extends Component {
    constructor(props) {
        super(props);

        this.state = {
            code: null,
            hasCode: false,
            token: null,
            left_minutes: 0,
            left_seconds: 0,
            error_msg: '',

            data: {phone: ''},

            // SmartId
            isSubmitting: false,
        };
    }

    startSign(values, actions) {

        if (this.props?.step !== undefined && this.props?.step === CONSENT_SIGNING) {
            //new version
            gtm.sendEvent('base', {
                event: 'loan_application_customer_data_sigining.started',
                products: this.props.trackData,
            }, 2);
        }


        this.setState({error_msg: ''});

        const client_type = this.props.client_type || 'P';

        let payload = this.mobileAuth
            ? {file_id: this.props.file_id, client_type: client_type, phone: this.state.data.phone}
            : {file_id: this.props.file_id, client_type: client_type};

        if (!this.mobileAuth) {
            this.setState({ isSubmitting: true });
        }

        axios.post(this.get_token_url, payload)
            .then(
                data => {
                    if (this.mobileAuth) {
                        actions.setSubmitting(false);
                    } else {
                        this.setState({ isSubmitting: false });
                    }

                    if (data.data.already_signed !== undefined && data.data.already_signed) {
                        this.props.callback();
                    } else {
                        this.startPingingForLogin(data.data);
                    }
                },
                error => {
                    let response_data = error.response.data;

                    if (this.mobileAuth) {
                        actions.setSubmitting(false);
                        actions.setErrors(response_data.errors);
                        actions.setStatus({
                            msg: response_data.message,
                            code: response_data.code,
                        });
                    } else {
                        this.setState({
                            error_msg: response_data.message,
                            isSubmitting: false
                        });
                    }
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });

        if (this.props.setActive) {
            this.props.setActive(this, this.mobileAuth ? 'msign' : 'smartid');
        }
    }

    startPingingForLogin(data) {
        stop();

        this.setState({
            code: data.control_code,
            hasCode: true,
            left_minutes: 2,
            left_seconds: 0,
            token: data.token
        });

        let _this = this;

        function handle() {

            if (_this.state.left_minutes > 0 || _this.state.left_seconds > 0) {
                axios.post(_this.get_token_status_url, {token: _this.state.token})
                    .then(
                        data => {
                            if (data.data.status === 'done') {
                                _this.stop();
                                _this.props.callback();
                            } else {
                                setTimeout(handle, 1000);
                            }
                        },
                        error => {
                            let response_data = error.response.data;
                            _this.setState({error_msg: response_data.message});
                            _this.stop();

                        }
                    )
                    .catch((a, b, c) => {
                        console.log(a, b, c);
                    });
            } else {
                _this.setState({error_msg: this.props.t('forms.signin_timeout')});
                _this.stop();
            }
        }

        function handle_timer() {
            let minutes_left = _this.state.left_minutes;
            let seconds_left = _this.state.left_seconds - 1;

            if (seconds_left < 0) {
                minutes_left--;
                seconds_left = 59;
            }

            if (minutes_left < 0) {
                _this.setState({error_msg: _this.props.t('forms.signin_timeout')});
                _this.stop();
            }

            _this.setState({
                left_minutes: minutes_left,
                left_seconds: seconds_left
            })
        }

        handle();
        this.timer_interval = setInterval(handle_timer, 1000);
    }

    stop() {
        clearInterval(this.interval);
        clearInterval(this.timer_interval);
        this.interval = null;
        this.timer_interval = null;

        this.setState({
            code: null,
            hasCode: false,
            token: null,
            isSubmitting: false
        });
    }

    waitingResult() {
        return (
            <div className='msign-code-card'>

                <p>{this.props.t('forms.signin_check_code_reminder')}
                    <span className='code font-weight-bold'> {this.state.code}</span></p>

                <p>{this.props.t('forms.awaiting_for_your_confirmation')}
                    <span
                        className='time font-weight-bold'> {this.state.left_minutes}:{this.state.left_seconds < 10 ? 0 : ''}{this.state.left_seconds}</span>
                </p>
            </div>);
    }
}

export default BaseElectronicSign;
